module.exports = __webpack_public_path__ + "static/media/foto_1.748b0847.png";